import createAsyncReducer from '@/store/createAsyncReducer.js';
import Fetch from "~/functions/Fetch.js";

const promptSetSubmissionsReducer = createAsyncReducer({
    name: 'promptSetSubmissions',
    initialState: {
        records: {},
        loading: false,
        errorMessage: ''
    },
    reducers: (create) => ({
        create: create.asyncThunk(
            async ({ promptSetSubmission }) => {
                return Fetch.post(Routes.ajax_prompt_set_submissions_path(), { body: { prompt_set_submission: promptSetSubmission } });
            },
            {
                pending: (state, action) => {
                    state.loading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.records = { ...state.records, ...action.payload };
                },
                rejected: (state, action) => {
                    state.loading = false;
                    state.errorMessage = action.error;
                }
            }
        ),
        query: create.asyncThunk(
            async(search) => {
                return Fetch.get(Routes.ajax_prompt_set_submissions_query_path({ ...search }));
            },
            {
                pending: (state, action) => {
                    state.loading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.records = { ...state.records, ...action.payload };
                },
                rejected: (state, action) => {
                    state.loading = false;
                    state.errorMessage = action.error;
                }
            }
        )
    })
});

export default promptSetSubmissionsReducer;